'use strict';

var RouteModuloBaseMixin = require("moduleFold/modulobase/scripts/mixins/RouteModuloBaseMixin");


/**
 * Registrazione delle route per il modulo bss/tracciatifile
 *
 * @class
 * @param {type} $stateProvider
 * @param {type} $urlRouterProvider
 * @param {type} $locationProvider
 */

function TracciatifileRoutes($stateProvider, $urlRouterProvider, $locationProvider){

  var self = {
        $stateProvider: $stateProvider,
        stato: "tracciatifile",
        url: "/tracciatifile",
        //templateUrl: "ricambiweb/tracciatifile/scripts/templates/tracciatifile.html",
        template: require("../templates/tracciatifile.html"),
        controller: ["$http", "$q", "$timeout", "$state", "$stateParams", "DSFactory", "GridFactory", "GridCfgFactory", "ToolbarSrv", "identifica", "$scope", "$compile", "ActionFactory", "ErrorManager", "FormDaGridFactory", "Valida", "TracciatifileFunzioniAggiuntive", require("../TracciatifileCtrl")],
        //controllerAs
        //middleware
        //data
        //identifica
    };

    angular.extend(self, RouteModuloBaseMixin.prototype);
    self.registra();
}

module.exports = TracciatifileRoutes;
